var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_40)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_645_40",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_645_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7707 0C15.52 0 16.5333 7.08267 16.5333 7.08267L16.552 14.4213H32.056V16.624H10.4C10.4 16.624 0 15.4373 0 31.9173C0 48.3973 9.07467 47.8107 9.07467 47.8107H14.488V40.1653C14.488 40.1653 14.1973 31.0453 23.4213 31.0453H38.7973C38.7973 31.0453 47.4373 31.184 47.4373 22.6507V8.53867C47.4373 8.53867 48.7493 0 31.7707 0ZM23.2213 4.93333C24.7627 4.93333 26.0107 6.18667 26.0107 7.73867C26.0107 9.288 24.7627 10.5413 23.2213 10.5413C21.6773 10.5413 20.432 9.288 20.432 7.73867C20.432 6.18667 21.6773 4.93333 23.2213 4.93333Z",
    fill: "#5C5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2319 64.0008C48.4773 64.0008 47.4639 56.9181 47.4639 56.9181L47.4453 49.5794H31.9413V47.3768H53.6026C53.6026 47.3768 64.0026 48.5634 64.0026 32.0834C64.0026 15.6034 54.9253 16.1901 54.9253 16.1901H49.5119V23.8354C49.5119 23.8354 49.8026 32.9554 40.5786 32.9554H25.2053C25.2053 32.9554 16.5653 32.8168 16.5653 41.3501V55.4621C16.5653 55.4621 15.2533 64.0008 32.2319 64.0008ZM40.7813 59.0674C39.2373 59.0674 37.9919 57.8141 37.9919 56.2621C37.9919 54.7128 39.2373 53.4594 40.7813 53.4594C42.3226 53.4594 43.5706 54.7128 43.5706 56.2621C43.5706 57.8141 42.3226 59.0674 40.7813 59.0674Z",
    fill: "#5C5B5B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.173db9ae2d6d736c6fb1db837a35e3fa.svg";
export { ForwardRef as ReactComponent };